var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hls-video"},[(_vm.hasClose)?_c('i',{staticClass:"el-icon-damai-close-o",on:{"click":function($event){return _vm.closeVideo()}}}):_vm._e(),_vm._v(" "),_c('video',{ref:"hlsVideo",staticClass:"hls-video-item",attrs:{"controls":""}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d723188","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HlsVideo/HlsVideo.vue
// module id = null
// module chunks = 